var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-838.439 -85)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    transform: "translate(838.439 85)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840.439 90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1319.443,412.361c2.04,0,4.08.01,6.12-.006a2.058,2.058,0,0,1,1.613.671c.543.577,1.16,1.091,1.659,1.7a2.358,2.358,0,0,1,.542,1.243c.073,1.166.027,2.34.023,3.511a1.463,1.463,0,0,1-.053.39.678.678,0,0,1-.806.543.659.659,0,0,1-.646-.716c.006-1.077.025-2.154-.015-3.229a1.7,1.7,0,0,0-.341-.842,4.266,4.266,0,0,0-4.11-1.806c-3.221.162-6.457.044-9.687.049a4.862,4.862,0,0,0-.9.075,1.515,1.515,0,0,0-1.378,1.426,3.687,3.687,0,0,0-.061.619c-.005,1.851.009,3.7-.012,5.553-.005.47.147.613.617.611,3.286-.018,6.573-.011,9.859-.008.659,0,.969.245.974.756a.7.7,0,0,1-.7.792c-.15.015-.3,0-.453,0-3.74,0-7.48.038-11.219-.017-1.663-.025-2.377.618-2.307,2.336.066,1.6.016,3.21.013,4.816,0,.669-.266,1.009-.791,1.028-.445.016-.754-.381-.756-1.005-.005-1.794-.009-3.589,0-5.383a3.2,3.2,0,0,1,2.627-3.23c.494-.1.662-.272.651-.8-.04-1.869-.019-3.739-.014-5.609a3.274,3.274,0,0,1,3.488-3.473C1315.4,412.358,1317.422,412.361,1319.443,412.361Z",
    transform: "translate(-1306.622 -412.355)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.66,566.152q-3.767,0-7.534,0a1.513,1.513,0,0,1-1.69-1.666q-.012-3.144,0-6.288a1.515,1.515,0,0,1,1.656-1.713c2.908-.014,5.816-.006,8.724,0a1.522,1.522,0,0,1,.448.049.613.613,0,0,1,.481.776,1.339,1.339,0,0,1-.58.64c-.169.1-.441.041-.668.042-2.625,0-5.249.013-7.874-.009-.506,0-.7.127-.693.664q.042,2.69,0,5.381c-.007.509.174.634.659.632,4.815-.016,9.63-.01,14.445-.009.17,0,.341-.009.509.005a.688.688,0,0,1,.722.763.65.65,0,0,1-.733.732c-.812.012-1.624.005-2.436.006Z",
    transform: "translate(-1332.165 -540.141)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1466.72,513.644c-1.306-1.335-2.605-2.676-3.924-4a.46.46,0,0,1-.062-.715,6.675,6.675,0,0,0,1.163-3.571,16.436,16.436,0,0,0-.316-1.829,6.435,6.435,0,0,0-7.629-4.524,6.47,6.47,0,1,0,4.945,11.739c.4-.263.619-.163.906.124,1.281,1.28,2.574,2.549,3.865,3.819.435.428.863.488,1.182.178C1467.2,514.524,1467.156,514.09,1466.72,513.644Zm-9.364-3.368a4.934,4.934,0,1,1,4.933-4.914A4.882,4.882,0,0,1,1457.356,510.275Z",
    transform: "translate(-1434.547 -489.052)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.c75ce991.svg";
export { ForwardRef as ReactComponent };